// Iter-276 — Legal Phase 4: client-side download of the user's personal-data
// export (data-subject access). Fetches the server-built export object and
// saves it as JSON or a flattened CSV.
import { authApi } from "@/services/api";

function triggerDownload(content, filename, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function csvCell(v) {
  if (v === null || v === undefined) return "";
  const s = typeof v === "object" ? JSON.stringify(v) : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

function toCsv(data) {
  const rows = [["Section", "Field", "Value"]];
  const push = (section, obj) => {
    Object.entries(obj || {}).forEach(([k, v]) => {
      if (Array.isArray(v)) return;
      rows.push([section, k, v]);
    });
  };
  push("Data subject", data.data_subject);
  push("Legal acceptance", data.legal_acceptance || {});
  const act = data.activity || {};
  rows.push(["Activity", "inspections_authored", act.inspections_authored]);
  rows.push(["Activity", "quotes_created", act.quotes_created]);
  rows.push(["Activity", "maintenance_jobs", act.maintenance_jobs]);
  rows.push(["Activity", "audit_events", act.audit_events]);
  (data.devices || []).forEach((d, i) => push(`Device ${i + 1}`, d));
  (act.recent_inspections || []).forEach((r) => {
    rows.push(["Recent inspection", r.door_reference || r.id, `${r.building || ""} · ${r.outcome || ""} · ${r.date || ""}`]);
  });
  return rows.map((r) => r.map(csvCell).join(",")).join("\r\n");
}

export async function downloadMyData(format = "json") {
  const { data } = await authApi.exportMyData();
  const stamp = new Date().toISOString().slice(0, 10);
  if (format === "csv") {
    triggerDownload(toCsv(data), `fdcheck-my-data-${stamp}.csv`, "text/csv;charset=utf-8");
  } else {
    triggerDownload(JSON.stringify(data, null, 2), `fdcheck-my-data-${stamp}.json`, "application/json");
  }
}
